import { RouteConfig } from 'vue-router';

import Details from '@/views/profile/Details.vue';

export function profileDetailsRoute(name: string): RouteConfig {
  return {
    path: '',
    name,
    component: Details,
    meta: {
      title: 'titles.profile.details'
    }
  };
}
